// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"62d46fab","123":"e57e68a7","229":"971b676d","230":"e382e000","244":"0b83db34","284":"4cad3407","440":"c8a4a0d5","583":"ac06e2e4","584":"9a5381a3","707":"a0f5156b","824":"05cd7951","840":"fc286483","925":"59d6f114"}[chunkId] + ".chunk.js";
};